export default __webpack_public_path__ + "resources/icons/d230-d724.png";